import 'src/styles/app.global.scss';

// IMPORTANT: DO NOT IMPORT ANYTHING THAT REQUIRES POLYFILLS IN THIS FILE

// sentry
import { captureException } from '@sentry/browser';

// We have to import the polyfills needed for React before we import React
import { importPolyfills } from 'src/polyfills/dynamicPolyfills';
import { initSentry } from 'src/utils/Sentry';

// Configure and Init Sentry
initSentry();

importPolyfills()
.catch(err => {
  console.error('Failed importing polyfills', err);
  captureException(err);
})
.then(() => {
  // this has to be a require
  try {
    require('./bootstrap');
  } catch (err) {
    window.console.error('bootstrap failed', err);
  }
});
